import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import './registerServiceWorker'
import VCalendar from 'v-calendar'
import moment from 'moment'

// styles
import '@/styles/index.styl'
import 'v-calendar/lib/v-calendar.min.css'

Vue.use(VCalendar, {
  componentPrefix: 'custom',
  firstDayOfWeek: 1,
  locale: 'pt-BR'
})

moment.locale('pt-br')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
